<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <refresh-button @refresh="refreshData()"></refresh-button>
            <add-button v-if="$moduleAccess('add_terminal')" @add="openAddDialog"></add-button>
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <!-- Insert View Dialog Content BELOW-->
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <action-dialog
              :type="dialogType"
              :disableSave="selected.length<1"
              :title="title + 's'"
              :dialog="addDialog"
              @saveDialog="saveAddDialog"
              @closeDialog="closeAddDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md6>
                    <jti-expansion-panel :panelName="'Select ' + title">
                      <v-data-table
                        v-model="selected"
                        item-key="id"
                        :headers="unassignedHeaders"
                        :items="unassignedItems"
                        select-all
                        hide-actions
                        disable-initial-sort
                      >
                        <template slot="headers" slot-scope="props">
                          <tr>
                            <th>
                              <v-checkbox
                                class="ml-5"
                                :input-value="props.all"
                                :indeterminate="props.indeterminate"
                                color="primary"
                                hide-details
                                @click.stop="toggleAll"
                              ></v-checkbox>
                            </th>
                            <th
                              v-for="header in props.headers"
                              :key="header.text"
                              :class="[
                              'column sortable', 
                              header.value === queryParams.order ? 'active' : '', 
                              'text-xs-'+header.align
                            ]"
                            >{{ header.text }}</th>
                          </tr>
                        </template>
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center">
                            <v-checkbox
                              class="ml-5"
                              color="primary"
                              v-model="props.selected"
                              hide-details
                            ></v-checkbox>
                          </td>
                          <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
                          <td class="text-xs-left text-uppercase">{{ props.item.code }}</td>
                        </template>
                      </v-data-table>
                    </jti-expansion-panel>
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'add' ? saveConfirmedAddDialog() :
                dialogType === 'assign' ? saveConfirmedSubscribeDialog() : ''"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >Row per Page:</p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="this.items.length < 10 ? true : false"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >{{ itemFrom + " -" + itemTo + " of " }} {{ totalItems }}</p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter"></filter-panel>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon
                    small
                    v-if="header.sortable"
                  >{{ header.sortNum === 1 ? "arrow_downward" : "arrow_upward"}}</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + queryParams.offset + 1}}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
              <!-- <td class="text-xs-left text-uppercase">{{ props.item.city }}</td> -->
              <!-- <td class="text-xs-left text-uppercase">{{ props.item.province }}</td> -->
              <td class="text-xs-left text-uppercase">{{ props.item.code }}</td>
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->
                <delete-button
                  v-if="$moduleAccess('delete_terminal')"
                  @delete="openDeleteDialog(props.item)"
                ></delete-button>
                <!-- <assign-button title="Assign to Project" @assign="openSubscribeDialog(props.item)"></assign-button> -->
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import DetailsContainer from "@/components/details_container/TerminalDetailsContainer";

export default {
  components: {
    DetailsContainer
  },
  data() {
    return {
      openFilter: false,
      title: "Terminal",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Code",
          align: "left",
          value: "code",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      unassignedHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Code",
          align: "left",
          value: "code",
          sortable: false
        }
      ],
      items: [],
      unassignedItems: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        order: "",
        desc: false,
        company_id: null,
        sub_company_id: null
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      selected: [],
      addDialog: false
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        this.queryParams.company_id = this.$store.state.company.id;
        this.queryParams.sub_company_id = this.$store.state.subcompany.id;

        let response = (await Services.getTerminals(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getTerminal(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
        data.code = data.code ? data.code.toUpperCase() : "";
        data.city = data.city ? data.city.toUpperCase() : "";
        data.province = data.province ? data.province.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setTerminals() {
      this.unassignedItems = [];
      this.unassignedItems = (await Services.getUnassignedTerminals({
        company_id: this.$store.state.company.id,
        sub_company_id: this.$store.state.subcompany.id
      })).data;
    },
    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setTerminals();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      // let test = JSON.parse(this.viewData.phone_no);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      this.openConfirmDialog = true;
    },
    async saveConfirmedAddDialog() {
      this.confirmLoading = true;

      const terminals = this.selected.map(item => {
        return {
          id: item.id
        };
      });

      const body = {
        terminals,
        sub_company_id: this.$store.state.subcompany.id
      };
      try {
        const response = await Services.assignTerminals(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAddDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Terminal(s) has been added"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteTerminal(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Terminal has been deleted!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.unassignedItems.slice();
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },
    async refreshData() {
      this.$refs.searchRef.clear();
      await this.getData();
    }
  }
};
</script>

<style scoped>
</style>
